import { Typography, Button } from '@mui/material';
import React from 'react';
import { Container } from '@mui/system';
import { knowMoreTimeLineObj } from 'assets/animation/portalAnimation';
import ScrollSpy from 'react-scrollspy-navigation';

const KnowMore: React.FC = () => {
    const knowMoreTimeLine = React.useRef(null);

    React.useEffect(() => {
        knowMoreTimeLineObj(knowMoreTimeLine);
    }, []);

    return (
        <section className="know-more" ref={knowMoreTimeLine}>
            <Container>
                <Typography variant="h3" className="section-title">
                    Are You Looking to Access Mental Health Service?
                </Typography>
                <ScrollSpy offsetTop={80} duration={1500}>
                    <></>
                    <Button
                        variant="outlined"
                        ref={React.createRef()}
                        title="Know More"
                        component="a"
                        href="#access-service"
                    >
                        Know More
                    </Button>
                </ScrollSpy>
            </Container>
        </section>
    );
};

export default React.memo(KnowMore);
